import mascot from "../assets/bonedmascot.png";
import bonedlogo from "../assets/bonedlogo.png";
import { useWindowDimensions } from "../hooks/useWindowDimensions";
import { StarworksButton } from "./StarworksButton";
import { YoutubeEmbed } from "./YoutubeEmbed";
import steamButton from "../assets/steam-store.png";
import guildCheese from "../assets/Guild_Cheese.png";
import Header from "./Header";
import Footer from "./Footer";

const BONEDDesktop = () => {
  return (
    <div
      className="d-flex space-backdrop"
      style={{ gap: "1rem", padding: "2rem 10%", width: "100%" }}
    >
      <div style={{ flex: "1" }}>
        <div className="d-flex" style={{ justifyContent: "center" }}>
          <img
            src={mascot}
            className="img-responsive"
            style={{ maxWidth: "560px" }}
          />
        </div>
      </div>
      <div style={{ flex: "1" }}>
        <div className="d-flex" style={{ justifyContent: "center" }}>
          <img
            src={bonedlogo}
            className="img-responsive"
            style={{ maxWidth: "550px" }}
          />
        </div>
        <YoutubeEmbed embedId="JwLy8d7DHLA" />
        <div
  className="d-flex"
  style={{
    justifyContent: "center",
    alignItems: "center",
    gap: "2rem",
    padding: "1rem",
    flexWrap: "wrap", 
  }}
>
  <a
    className="no-underline d-flex"
    style={{ justifyContent: "center", alignItems: "center" }}
    href="https://guild-cheese.vercel.app/"
    target="_blank"
  >
    <img
      src={guildCheese}
      className="img-responsive"
      style={{ maxWidth: "200px", height: "auto" }}
      alt="Guild Cheese Logo"
    />
  </a>

  <a
    className="no-underline d-flex"
    style={{ justifyContent: "center", alignItems: "center" }}
    href="https://store.steampowered.com/app/3127600/Boned/"
    target="_blank"
  >
    <img
      src={steamButton}
      className="img-responsive"
      style={{ maxWidth: "300px", height: "auto" }}
      alt="Steam Button"
    />
  </a>
</div>
      </div>
    </div>
  );
};

const BONEDMobile = () => {
  return (
    <div
      className="d-flex dotted-backdrop"
      style={{
        flexDirection: "column",
        gap: "1rem",
        padding: "2rem 10%",
        width: "100%",
      }}
    >
      <div className="d-flex" style={{ justifyContent: "center" }}>
        <img
          src={bonedlogo}
          className="img-responsive"
          style={{ maxWidth: "550px" }}
        />
      </div>
      <div
        className="d-flex"
        style={{ justifyContent: "center", padding: "1rem" }}
      >
        <a
          className="no-underline d-flex"
          style={{ justifyContent: "center" }}
          href="https://store.steampowered.com/app/3127600/Boned/"
          target="_blank"
        >
          <img
            src={steamButton}
            className="img-resposive"
            style={{ maxWidth: "75%" }}
          />
        </a>
        </div>
        <div className="d-flex" style={{ justifyContent: "center" }}>
        <img
              src={guildCheese}
              className="img-resposive"
              style={{ maxWidth: "70%",  maxHeight: "70%"}}
              ref="https://guild-cheese.vercel.app/"
            />
      </div>
      <YoutubeEmbed embedId="JwLy8d7DHLA" />
    </div>

  );
};

const BONED = () => {
  const screenSize = useWindowDimensions();

  return (
    <>
      <Header />
      {screenSize.width < 990 ? <BONEDMobile /> : <BONEDDesktop />}
      <Footer />
    </>
  );
};


export default BONED;